export default "__VITE_ASSET__DUJRAHeG__"